/* ==========================================================================
   Hybrid Health — Scary Deals landing page
   File: assets/scary-deals.js
   Vanilla JS, no dependencies. Handles:
     - variant selection (price / compare-at / savings / sold-out state)
     - add to cart via /cart/add.js with loading + error states
     - optional theme cart-drawer integration (Dawn-style), toast fallback
     - category filters
     - countdown (absolute Europe/London-offset timestamps, real expiry state)
     - theme editor section reloads (shopify:section:load)
   ========================================================================== */
(function () {
  'use strict';
  if (window.ScaryDeals) { return; } // guard: sections may each include this file

  var PREVIEW = !!window.SD_PREVIEW; // set only by the offline design preview
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Money ------------------------------------------------------------------ */
  function money(cents, fmt) {
    fmt = fmt || '£{{amount}}';
    var v = cents / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var s;
    switch (key) {
      case 'amount_no_decimals':
        s = Math.round(v).toLocaleString('en-GB'); break;
      case 'amount_with_comma_separator':
        s = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator':
        s = String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_with_space_separator':
        s = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '); break;
      default:
        s = v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  /* Toast ------------------------------------------------------------------ */
  var toastEl = null, toastTimer = null;
  function toast(message, linkHref, linkLabel) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sd-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    clearTimeout(toastTimer);
    toastEl.classList.remove('is-leaving');
    toastEl.innerHTML = '';
    var text = document.createElement('span');
    text.textContent = message;
    toastEl.appendChild(text);
    if (linkHref) {
      var a = document.createElement('a');
      a.className = 'sd-toast__link';
      a.href = linkHref;
      a.textContent = linkLabel || 'View cart';
      toastEl.appendChild(a);
    }
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'sd-toast__close';
    close.setAttribute('aria-label', 'Dismiss');
    close.innerHTML = '&times;';
    close.addEventListener('click', hideToast);
    toastEl.appendChild(close);
    toastEl.hidden = false;
    toastTimer = setTimeout(hideToast, 6000);
  }
  function hideToast() {
    if (!toastEl) return;
    toastEl.classList.add('is-leaving');
    setTimeout(function () { toastEl.hidden = true; }, 220);
  }

  /* Cart drawer detection (Dawn / Dawn-derived themes) ---------------------- */
  function findDrawer() {
    var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function') return el;
    return null;
  }

  /* Product card ------------------------------------------------------------ */
  function initCard(card) {
    if (card.dataset.sdInit) return;
    card.dataset.sdInit = '1';

    var form = card.querySelector('[data-sd-form]');
    if (!form) return;
    var select = card.querySelector('[data-sd-variant-select]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = card.querySelector('[data-sd-add]');
    var label = card.querySelector('[data-sd-add-label]');
    var err = card.querySelector('[data-sd-error]');
    var priceNow = card.querySelector('[data-sd-price-now]');
    var priceWas = card.querySelector('[data-sd-price-was]');
    var priceSave = card.querySelector('[data-sd-price-save]');
    var fmt = card.dataset.sdMoney || '£{{amount}}';
    var addLabel = btn ? (btn.dataset.sdLabelAdd || 'Add to cart') : 'Add to cart';
    var soldLabel = btn ? (btn.dataset.sdLabelSold || 'Sold out') : 'Sold out';

    var variants = [];
    var json = card.querySelector('[data-sd-variants]');
    if (json) { try { variants = JSON.parse(json.textContent) || []; } catch (e) { variants = []; } }

    function currentVariant() {
      var id = select ? select.value : (idInput ? idInput.value : null);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function render() {
      var v = currentVariant();
      if (!v) return;
      if (priceNow) priceNow.textContent = money(v.price, fmt);
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) {
        priceWas.hidden = !hasCompare;
        if (hasCompare) priceWas.innerHTML = '<s>' + money(v.compare_at_price, fmt) + '</s>';
      }
      if (priceSave) {
        priceSave.hidden = !hasCompare;
        if (hasCompare) priceSave.textContent = 'Save ' + money(v.compare_at_price - v.price, fmt);
      }
      if (btn) {
        btn.disabled = !v.available;
        if (label) label.textContent = v.available ? addLabel : soldLabel;
      }
      hideError();
    }

    function showError(msg) {
      if (!err) return;
      err.textContent = msg;
      err.hidden = false;
    }
    function hideError() { if (err) { err.hidden = true; err.textContent = ''; } }
    function setLoading(on) {
      if (!btn) return;
      btn.classList.toggle('is-loading', on);
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) btn.disabled = true; else render();
    }

    if (select) select.addEventListener('change', render);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      var v = currentVariant();
      if (v && !v.available) { showError('This option is sold out.'); return; }

      var mode = (card.closest('[data-sd-cart-mode]') || {}).dataset;
      mode = (mode && mode.sdCartMode) || 'toast';
      var drawer = mode === 'drawer' ? findDrawer() : null;

      setLoading(true);
      hideError();

      if (PREVIEW) {
        setTimeout(function () {
          setLoading(false);
          toast('Preview only — the live page posts this to /cart/add.js', null);
        }, 700);
        return;
      }

      var fd = new FormData(form);
      if (drawer) {
        try {
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        } catch (ex) { drawer = null; }
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          var j = res.json || {};
          if (!res.ok || j.status) {
            throw new Error(j.description || j.message || 'Could not add this item to your cart.');
          }
          document.dispatchEvent(new CustomEvent('scary-deals:added', { detail: j }));
          if (mode === 'redirect') { window.location.href = root + 'cart'; return; }
          if (drawer) {
            try {
              drawer.renderContents(j);
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              return;
            } catch (ex) { /* fall through to toast */ }
          }
          toast('Added to cart', root + 'cart', 'View cart');
        })
        .catch(function (ex) {
          showError(ex && ex.message ? ex.message : 'Could not add this item to your cart. Please try again.');
        })
        .then(function () { setLoading(false); });
    });

    render();
  }

  /* Filters ------------------------------------------------------------------ */
  function initFilters(section) {
    var bar = section.querySelector('[data-sd-filters]');
    if (!bar || bar.dataset.sdInit) return;
    bar.dataset.sdInit = '1';
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-sd-card]'));
    var count = section.querySelector('[data-sd-count]');
    var empty = section.querySelector('[data-sd-empty]');
    var allLabel = bar.dataset.sdAllLabel || 'All';
    var order = (bar.dataset.sdOrder || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    function catsOf(card) {
      return (card.dataset.categories || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    var cats = [];
    cards.forEach(function (c) { catsOf(c).forEach(function (x) { if (cats.indexOf(x) < 0) cats.push(x); }); });
    cats.sort(function (a, b) {
      var ia = order.indexOf(a), ib = order.indexOf(b);
      if (ia < 0) ia = 999; if (ib < 0) ib = 999;
      return ia - ib;
    });
    if (cats.length < 2) { bar.hidden = true; return; }

    var buttons = [];
    function apply(cat) {
      var shown = 0;
      cards.forEach(function (c) {
        var show = cat === '*' || catsOf(c).indexOf(cat) > -1;
        c.hidden = !show;
        if (show) shown++;
      });
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cat === cat ? 'true' : 'false'); });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
    }
    function makeBtn(labelText, cat) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sd-filters__btn';
      b.dataset.cat = cat;
      b.textContent = labelText;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { apply(cat); });
      bar.appendChild(b);
      buttons.push(b);
    }
    bar.innerHTML = '';
    makeBtn(allLabel, '*');
    cats.forEach(function (c) { makeBtn(c, c); });
    apply('*');
  }

  /* Countdown ----------------------------------------------------------------- */
  function initCountdown(el) {
    if (el.dataset.sdInit) return;
    el.dataset.sdInit = '1';
    var start = Date.parse(el.dataset.sdStart || '');
    var end = Date.parse(el.dataset.sdEnd || '');
    var label = el.querySelector('[data-sd-cd-label]');
    var digits = el.querySelector('[data-sd-cd-digits]');
    if (isNaN(end)) { el.hidden = true; return; } // misconfigured: hide rather than show a broken clock
    var d = el.querySelector('[data-sd-cd="d"]'), h = el.querySelector('[data-sd-cd="h"]'),
        m = el.querySelector('[data-sd-cd="m"]'), s = el.querySelector('[data-sd-cd="s"]');
    var timer;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var now = Date.now(), target, text;
      if (!isNaN(start) && now < start) { target = start; text = el.dataset.sdLabelStarts || 'Sale starts in'; }
      else if (now < end) { target = end; text = el.dataset.sdLabelEnds || 'Sale ends in'; }
      else {
        el.classList.add('is-ended');
        if (label) label.textContent = el.dataset.sdLabelEnded || 'This sale has ended';
        if (digits) digits.hidden = true;
        clearInterval(timer);
        return;
      }
      var diff = Math.max(0, target - now);
      var days = Math.floor(diff / 864e5);
      var hrs = Math.floor(diff % 864e5 / 36e5);
      var mins = Math.floor(diff % 36e5 / 6e4);
      var secs = Math.floor(diff % 6e4 / 1e3);
      if (label) label.textContent = text;
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* Init ------------------------------------------------------------------------ */
  function init(scope) {
    scope = scope || document;
    var cards = scope.querySelectorAll ? scope.querySelectorAll('[data-sd-card]') : [];
    Array.prototype.forEach.call(cards, initCard);
    var grids = scope.querySelectorAll ? scope.querySelectorAll('[data-sd-grid]') : [];
    Array.prototype.forEach.call(grids, initFilters);
    if (scope !== document && scope.matches && scope.matches('[data-sd-grid]')) initFilters(scope);
    var cds = scope.querySelectorAll ? scope.querySelectorAll('[data-sd-countdown]') : [];
    Array.prototype.forEach.call(cds, initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Theme editor: sections are re-rendered when settings change.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.ScaryDeals = { init: init, money: money, toast: toast };
})();
